import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CerereStatusService {
  private token!: string;
  private httpOptions: any;
  private basePath = environment.interop.basePath;
  private getStatusUrl =
    this.basePath +
    environment.interop.urbanism.nomenclatoare.cerereStatus.getCerereStatuses;

  constructor(private http: HttpClient) {}

  getStatuses() {
    return this.http
      .get<{ errors: boolean; data: any[]; status_code: number }>(
        this.getStatusUrl
      )
      .pipe(
        map((response) =>
          response.data.map((item) => ({
            id: item.id,
            name: item.name,
          }))
        ),
        catchError((error) => {
          console.error('Error in get request statuses:', error);
          return throwError(error);
        })
      );
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }
}
